import React, { PureComponent } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Divider,
  Button,
  Grid,
  Typography,
} from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'
import _ from 'lodash'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

class EditChecklistModal extends PureComponent {
  state = {
    isCharged: false,
    id: '',
    name: '',
    categoryId: '',
    taskDetails: [],
  }

  updateChecklist = () => {
    const { id, name, categoryId, taskDetails } = this.state

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid checklist name')
      return
    }
    if (!isValidString(categoryId)) {
      this.props.onError('Please provide a valid checklist category')
      return
    }
    // if (taskDetails.length === 0) {
    //   this.props.onError("Please provide a checklist taskDetails");
    //   return;
    // }

    this.props.updateChecklist({ id, name, categoryId, taskDetails })
  }

  onClose = () => {
    this.setState({
      isCharged: false,
      id: '',
      name: '',
      categoryId: '',
      taskDetails: [],
    })
  }

  onOpen = (item) => {
    if ((!this.state.isCharged && item.id) || (this.state.id && item.id != this.state.id)) {
      _.map(item.taskDetails, (task) => {
        delete task.__typename
      })
      this.setState({
        isCharged: true,
        id: item.id,
        name: item.name,
        categoryId: item.categoryId,
        taskDetails: item.taskDetails,
      })
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onChangeTask = (e, index) => {
    var tasks = [...this.state.taskDetails]
    tasks[index][e.target.name] = e.target.value
    this.setState({
      taskDetails: tasks,
    })
  }

  render() {
    const { forwardedRef, categoryList, item } = this.props

    const { name, categoryId, taskDetails } = this.state

    const addTask = () => {
      var taskAdded = [...taskDetails]
      taskAdded.push({
        position: taskAdded.length + 1,
        name: '',
      })
      this.setState({
        taskDetails: taskAdded,
      })
    }

    const removeTask = (event, index) => {
      var taskRemoved = [...taskDetails]
      taskRemoved.splice(index, 1)
      taskRemoved.map((task, i) => {
        task.position = task.position >= index + 1 ? task.position - 1 : task.position
      })
      this.setState({
        taskDetails: taskRemoved,
      })
    }

    return (
      <ModalDialog
        title={'Edit Checklist'}
        size={'lg'}
        ref={forwardedRef}
        onConfirm={this.updateChecklist}
        onClose={this.onClose}
        onOpen={this.onOpen(item)}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input
            name="name"
            value={name}
            onChange={this.onChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Category *</InputLabel>
          <Select
            value={categoryId}
            name="categoryId"
            onChange={this.onChange}
            MenuProps={MenuProps}
          >
            {categoryList &&
              categoryList.map((category, i) => (
                <MenuItem key={i} value={category.id}>
                  {category.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <Grid style={{ margin: '10px 0px' }}>
          <Typography variant="subheading" style={{ float: 'right' }}>
            <Button size="small" className="primary-button" onClick={addTask}>
              {' '}
              Add Task{' '}
            </Button>
          </Typography>
          <Typography variant="title" style={{ paddingTop: '10px' }}>
            Task Details
          </Typography>
          <Divider style={{ display: 'block' }} />
        </Grid>
        <Grid container>
          {taskDetails &&
            taskDetails.map((task, index) => {
              return (
                <React.Fragment key={index}>
                  <Grid item sm={2}>
                    <FormControl fullWidth className="margin-bottom-small">
                      <InputLabel>Position</InputLabel>
                      <Input
                        name="position"
                        disabled
                        value={task.position}
                        fullWidth
                        inputProps={{
                          maxLength: 50,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item sm={8}>
                    <FormControl fullWidth className="margin-bottom-small">
                      <InputLabel>Name *</InputLabel>
                      <Input
                        name="name"
                        value={task.name}
                        onChange={(event) => this.onChangeTask(event, index)}
                        fullWidth
                        inputProps={{
                          maxLength: 50,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item sm={2} style={{ textAlign: 'right' }}>
                    <Button
                      data-id={index}
                      style={{ marginTop: '16px' }}
                      size="small"
                      className="danger-button"
                      onClick={(event) => removeTask(event, index)}
                    >
                      {' '}
                      Remove{' '}
                    </Button>
                  </Grid>
                </React.Fragment>
              )
            })}
          {/* {
              taskDetails.length == 0
            } */}
        </Grid>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(EditChecklistModal)



// WEBPACK FOOTER //
// ./src/components/Modal/EditChecklistModal.js